// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import i18n from './lang/i18n'
import store from './store/index'
import CripLoading from 'crip-vue-loading'
import ElementUI from 'element-ui'
import {HTTP} from './CallAPI'
import Notifications from 'vue-notification'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import Loading from 'vue-full-loading'
import Error from '@/components/error'
import HTMLTextarea from '@/components/common/html-textarea'
import {permission} from '@/directives/directive-permission'
import CKEDITOR from 'glviews-ckeditor5'
import VueCkeditor from 'vue-ckeditor5'
import Permission from '@/permission'
import Status from '@/status'
import {ChecklistPermission} from '@/directives/checklist-permission'
import Chat from 'vue-beautiful-chat'
import locale from 'element-ui/lib/locale/lang/en'
import 'element-ui/lib/theme-chalk/index.css'

const options = {
  editors: {
    classic: CKEDITOR.ClassicEditor,
    balloon: CKEDITOR.BalloonEditor,
    document: CKEDITOR.DecoupledEditor,
    inline: CKEDITOR.InlineEditor
  },
  name: 'ckeditor'
}

Vue.use(VueCkeditor.plugin, options)
Vue.use(Chat)
Vue.use(ElementUI, { locale })
Vue.use(CripLoading, {HTTP, applyOnRouter: false})
Vue.use(BootstrapVue)
Vue.use(Notifications)
Vue.use(require('vue-moment'))
Vue.component('treeselect', Treeselect)
Vue.component('loading', Loading)
Vue.component('error', Error)
Vue.component('HTMLTextarea', HTMLTextarea)
Vue.directive('permission', permission)
Vue.directive('chkpermission', ChecklistPermission)
Vue.use(require('vue-scrollto'))

Vue.prototype.$permissions = Permission
Vue.prototype.$status = Status

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  store,
  Permission,
  template: '<App/>',
  components: {
    App
  }
})



// WEBPACK FOOTER //
// ./src/main.js